import { Component, OnInit, Input } from '@angular/core';
import { CorrespondenceTimelineService } from '../../../shared/services/correspondence-timeline.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-item-pdf-generator',
  templateUrl: './item-pdf-generator.component.html',
  styleUrls: ['./item-pdf-generator.component.scss']
})
export class ItemPdfGeneratorComponent implements OnInit {

  @Input() caseId: number | undefined;
  @Input() item: any | undefined;

  generatingPDF: boolean = false;
  createButtonDisabled: boolean = true;
  generatingError: boolean = false;
  errorMessage: string = "";

  constructor(public activeModal: NgbActiveModal,
              private correspondenceTimelineService: CorrespondenceTimelineService) {

    
  }

  ngOnInit(): void {
    this.generatingPDF = true;

    this.correspondenceTimelineService.generatePDF( this.caseId, this.item.id).subscribe(response => {

      if(response.success)
      {
        this.activeModal.close(true);
        this.correspondenceTimelineService.refreshCaseTimeline.next();
      }
      else{
        this.generatingError = true;
        this.errorMessage = response.errorText;
      }

    }, error => {


      this.generatingError = true;
      if(error.status == 999)
        this.errorMessage = error.error;
      else if(error.status == 500 )
        this.errorMessage = "Internal Error";
      else
        this.errorMessage = error.statusText;


    });
  }

}
